import {MI} from "../init";
import {copyArray} from "../../framework/src/helpers";
import {arrayCircleGetElement} from "../utils/helpers";

/**
 * @constructor
 * @returns {ReelMotion}
 */
export function ReelMotion() {

    /** * @type {SpinReel} */
    this._reel;

    /** @type {ReelPrinter} */
    this._printer;

    /** @type {GameConfig} */
    this._gameConfig;

    /** @type {ServerConfig} */
    this._serverConfig;

    //this._gear = new ReelGear(this._reel);
    //this._gear.onLoop(this._move.bind(this));

    /** @type {number} */
    this._spinDuration;
    /** @type {number} */
    this._accHeight;
    /** @type {number} */
    this._accMoveTime;
    /** @type {number} */
    this._accMoveBackTime;
    /** @type {number} */
    this._spinSpeed;
    /** @type {number} */
    this._brakeHeight;
    /** @type {number} */
    this._brakeMoveBackTime;
    /** @type {number} */
    this._brakeMoveTime;

    /** @type {number} */
    this.state = this.states["idle"];

    /** @type {Array<AbstractSymbol>} */
    this._stopSymbolsBuffer = [];

    /** @type {number} */
    this._stoppingSymbolsLeft;
    /** @type {number} */
    this._symbolsLeftToStop;

    /** @type {boolean} */
    this._requestStop = false;

    /** @type {Function|null} */
    this._resolve;

    /** @type {Function|null} */
    this._onSpin;
    /** @type {Function|null} */
    this._onStop;
    /** @type {Function|null} */
    this._onBrakeDown;

    /** @type {Function|null} */
    this._onBrakeUp;

    /** @type {Object<string,MadnesTween>} */
    this._tweens = {};
};

/** @const  */
ReelMotion.prototype.states = {
    "idle": 0,
    "accUpStart": 1,
    "accUp": 2,
    "accDownStart": 3,
    "accDown": 4,
    "spin": 5,
    "prestopping": 6,
    "stopping": 7,
    "brakeDownStart": 8,
    "brakeDown": 9,
    "brakeUpStart": 10,
    "brakeUp": 11,
    "stop": 12
};

/**
 * @param {GameConfig} gameCfg
 * @param {ServerConfig} serverCfg
 * @param {SpinReel} reel
 * @param {ReelPrinter} printer
 * @returns {undefined}
 */
ReelMotion.prototype.init = function(gameCfg, serverCfg, reel, printer) {
    this._gameConfig = gameCfg;
    this._serverConfig = serverCfg;
    this._reel = reel;
    this._printer = printer;

    this.initConfig(serverCfg, gameCfg);
};

/**
 * @public
 * @param {ServerConfig} serverConfig
 * @param {GameConfig} gameCfg
 * @returns {undefined}
 */
ReelMotion.prototype.initConfig = function(serverConfig, gameCfg) {
    this._spinDuration = serverConfig.getSpinDuration() + 3;
    this._accHeight = serverConfig.getAccHeight() * (gameCfg.symbolHeight + gameCfg.symbolOffsetY);
    this._accMoveTime = serverConfig.getAccMoveTime() * 1000;
    this._accMoveBackTime = serverConfig.getAccMoveBackTime() * 1000;
    this._brakeHeight = serverConfig.getBrakeHeight() * (gameCfg.symbolHeight + gameCfg.symbolOffsetY);
    this._brakeMoveBackTime = serverConfig.getBrakeMoveBackTime() * 1000;
    this._brakeMoveTime = serverConfig.getBrakeMoveTime() * 1000;

    this.reinitSpeed();
};

ReelMotion.prototype.reinitSpeed = function() {
    this._spinSpeed = this._serverConfig.getSpinCommonSpeed() * (this._gameConfig.symbolHeight + this._gameConfig.symbolOffsetY);
};

/**
 * @returns {number}
 */
ReelMotion.prototype.getSpinSpeed = function() {
    return this._spinSpeed;
};

/**
 * @public
 * @param {number} speed
 */
ReelMotion.prototype.setSpinSpeed = function(speed) {
    this._spinSpeed = speed;
    //this._spinSpeed = this.calcSpinSpeed(symbols);
};

/**
 * @param {number} symbols
 * @returns {number}
 */
ReelMotion.prototype.calcSpinSpeed = function(symbols) {
    return symbols * (this._gameConfig.symbolHeight + this._gameConfig.symbolOffsetY);
};

ReelMotion.prototype.tick = function(delta) {
    this._move(this._spinSpeed * (delta / 1000));
};

///**
// * @param {number} toSymbols - symbols per second
// * @returns {undefined}
// */
//ReelMotion.prototype.slowDown = function(toSymbols, cb) {
//
//	var _self = this;
//
//	var obj = { 'val': this._spinSpeed };
//	var toSpeed = this._calcSpinSpeed(toSymbols);
//
//	MI.addTween().to(obj, { 'val': toSpeed }, {
//		'duration': 300,
//		//'delay': 200,
//		'update': function() {
//			_self._spinSpeed = obj['val'];
//		},
//		'callback': function() {
//			_self._spinSpeed = toSpeed;
//			cb && cb();
//		}
//	});
//};

ReelMotion.prototype.start = function() {

    this._stoppingSymbolsLeft = this._reel.getSymbols().length - 1;

    this._symbolsLeftToStop = /*this._stoppingSymbolsLeft +*/ this._spinDuration - this._stoppingSymbolsLeft;
    if(this._symbolsLeftToStop < 0) {
        this._symbolsLeftToStop = 0;
    }
    //console.log(this._symbolsLeftToStop);
    this._requestStop = false;

    this._reel.shiftY = 0;

    return new Promise(function(res) {
        if(this.state !== this.states["idle"]) {
            //console.log('reel id:' + this._reel.id + 'is running');
            return;
        }

        this.state = this.states["accUpStart"];
        this._move(0);

        this._resolve = res;
    }.bind(this));
};

ReelMotion.prototype.stop = function() {
    this._requestStop = true;
};

/**
 * @param {number} symbolsToStop
 * @returns {undefined}
 */
ReelMotion.prototype.addSymbolsToStop = function(symbolsToStop) {
    this._symbolsLeftToStop += symbolsToStop;
};

ReelMotion.prototype._move = function(shift) {

    if(this.state === this.states["idle"]) {
        return;
    }

    var _self = this;

    switch(this.state) {
        case this.states["accUpStart"]:

            this.state = this.states["accUp"];
            var obj = { 'shiftY': 0 };

            if(!this._accMoveTime) {
                _self.state = _self.states["accDownStart"];
                _self._move(0);
                return;
            }

            var height = this._accHeight;
            if(height)
            {
                height *= -1;
            }

            this._tweens["acc_up"] = MI.addTween().to(obj, { 'shiftY': height }, {
                'duration': this._accMoveTime,
                'update': function () {
                    _self._reel.shiftY = obj['shiftY'];
                    _self._printer.print(_self._reel);
                },
                'callback': function() {

                    _self._printer.print(_self._reel);
                    _self.state = _self.states["accDownStart"];
                    _self._move(0);
                }
            });

            break;

        case this.states["accDownStart"]:

            this.state = this.states["accDown"];
            var obj = { 'shiftY': this._reel.shiftY };

            if(!this._accMoveBackTime) {
                _self.state = _self.states["spin"];
                return;
            }

            this._tweens["acc_down"] = MI.addTween().to(obj, { 'shiftY': 0 }, {
                'duration': this._accMoveBackTime,
                'update': function() {
                    _self._reel.shiftY = obj['shiftY'];
                    _self._printer.print(_self._reel);
                },
                'callback': function() {

                    _self._onSpin && _self._onSpin();

                    _self.state = _self.states["spin"];
                    _self._printer.print(_self._reel);

                }
            });
            break;

        case this.states["spin"]:

            if(this._canStop()) {

                this.state = this.states["stopping"];
                this._move(shift);

                this._requestStop = false;
                break;
            }

            this._reel.shiftY += shift;
            this._moveSpin();
            break;

        /*case this.states["prestopping"]:
            this.state = this.states["stopping"];
            console.log(this._reel.searching);
            this._reel.shiftY += shift;
            this._moveStopping();*/

        case this.states["stopping"]:
            this._reel.shiftY += shift;
            this._moveStopping();

            break;

        case this.states["brakeDownStart"]:

            this.state = this.states["brakeDown"];

            this._onBrakeDown && this._onBrakeDown();

            this._reel.shiftY = 0;

            var obj = { 'shiftY': 0 };

            this._tweens["brake_down"] = MI.addTween().to(obj, { 'shiftY': this._brakeHeight }, {
                'duration': this._brakeMoveTime,
                'update': function() {
                    _self._reel.shiftY = obj['shiftY'];
                    _self._printer.print(_self._reel);
                },
                'callback': function() {
                    _self._printer.print(_self._reel);
                    _self.state = _self.states["brakeUpStart"];
                    _self._move(0);
                }
            });
            break;

        case this.states["brakeUpStart"]:

            this.state = this.states["brakeUp"];
            var obj = { 'shiftY': this._reel.shiftY };

            this._onBrakeUp && this._onBrakeUp();

            this._tweens["brake_up"] = MI.addTween().to(obj, { 'shiftY': 0 }, {
                'duration': this._brakeMoveBackTime,
                'update': function() {
                    _self._reel.shiftY = obj['shiftY'];
                    _self._printer.print(_self._reel);
                },
                'callback': function() {
                    _self._printer.print(_self._reel);
                    _self.state = _self.states["stop"];
                    //this._move(0);
                }
            });
            break;

        case this.states["stop"]:

            this._reel.shiftY = 0;

            this._onStop && this._onStop();

            this.reinitSpeed();
            this._resolve && this._resolve();

            this.state = this.states["idle"];
            this._clearStopSymbolBuffer();
            this._reel.forceStopping = false;
            break;
    }
};

/**
 * @returns {boolean}
 */
ReelMotion.prototype._canStop = function() {

    if(!this._requestStop || this._stopSymbolsBuffer.length === 0) { //if not requested for stop by server result
        return false;
    }

    /*if(this._reel.id === 0) {
        console.log(this._symbolsLeftToStop);
    }*/

    if(MI.controls.isForceStop()) {
        this._reel.forceStopping = true;
        return true;
    } else {
        return this._symbolsLeftToStop <= 0;
    }

    /*if() {
        return this._stoppingSymbolsLeft <= 0;
    } else {
        return this._symbolsLeftToStop <= 0;
    }*/
};

ReelMotion.prototype._moveSpin = function() {
    var shift = this._gameConfig.symbolHeight + this._gameConfig.symbolOffsetY;

    while(this._reel.shiftY > shift) {
        this._reel.shiftY -= shift;

        var tmpSymb = this._reel.getSymbols().pop();
        tmpSymb.kill();

        tmpSymb = arrayCircleGetElement(this._reel.getSpinSymbols(), ++this._reel.symbolPosition);
        tmpSymb.revive();
        this._reel.getSymbols().unshift(tmpSymb);

        this._symbolsLeftToStop--;
    }

    if(this._symbolsLeftToStop < 0) {
        this._symbolsLeftToStop = 0;
    }

    this._printer.print(this._reel);
};

ReelMotion.prototype._moveStopping = function() {

    var shift = this._gameConfig.symbolHeight + this._gameConfig.symbolOffsetY;

    while(this._reel.shiftY > shift) {
        this._reel.shiftY -= shift;

        var tmpSymb = this._reel.getSymbols().pop();
        tmpSymb.kill();

        if(!this._stopSymbolsBuffer.length) {
            tmpSymb = arrayCircleGetElement(this._reel.getSpinSymbols(), ++this._reel.symbolPosition);
        } else {
            tmpSymb = this._stopSymbolsBuffer.pop();
        }

        tmpSymb.revive();
        this._reel.getSymbols().unshift(tmpSymb);

        this._stoppingSymbolsLeft--;

        if(this._stoppingSymbolsLeft <= 0) {
            this.state = this.states["brakeDownStart"];
            this._move(0);
            break;
        }
    }

    this._printer.print(this._reel);
};

ReelMotion.prototype.setResultSymbols = function(symbols) {
    if(this.state <= this.states["spin"]) { //if not stopping
        this._stopSymbolsBuffer = copyArray(symbols);
    }
};

ReelMotion.prototype._clearStopSymbolBuffer = function() {
    this._stopSymbolsBuffer = [];
};

/*ReelMotion.prototype.isMoving = function() {
   return this.state !== this.states["stop"] && this.state !== this.states["idle"];
};*/

ReelMotion.prototype.onSpin = function(func) {
    this._onSpin = func;
};

ReelMotion.prototype.onStop = function(func) {
    this._onStop = func;
};

ReelMotion.prototype.onBrakeDown = function(func) {
    this._onBrakeDown = func;
};

ReelMotion.prototype.onBrakeUp = function(func) {
    this._onBrakeUp = func;
};

ReelMotion.prototype.destroy = function() {

    for(var key in this._tweens) {
        this._tweens[key].stop();
    }

    for(var i = 0; i < this._stopSymbolsBuffer.length; i++) {
        this._stopSymbolsBuffer[i].destroy();
    }

    this._stopSymbolsBuffer.length = 0;
};